<template>
  <div v-if="show" class="page flex-column flex-row-align-center">
    <div class="page-content bg-white radius-clip-5">
      <div class="page-content-title flex-center">

        <p class="font-size-20 font-bold">认证失败</p>
      </div>
      <div class="page-content-desc flex">
        <div class="page-content-desc-icon">
          <img src="../../assets/icon-lib-auth-fail.png">
        </div>
        <div class="page-content-desc-info flex-column flex-row-align-center">
          <p class="font-size-14">{{ msg }}</p>
          <!-- <p class="font-size-14">请联系客服人员</p> -->
        </div>
      </div>

      <div class="page-content-btn flex-center">
        <div class="page-content-btn-body bg-282B80 font-size-14 font-color-white radius-clip-5 flex-center" @click="show = false">知道了</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      msg: ''
    }
  },
  methods: {
    showauthfail(v) {
      this.msg = v
      this.show = true
    }
  }
}
</script>
<style src="@/styles/pc.css" scoped>
</style>
<style scoped>
  .page {
    position: fixed;
    top: 70px;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 99;
    padding-top: 128px;
  }

  .page-content {
    width: 420px;
    height: 224px;
  }

  .page-content-title {
    margin-top: 30px;
    height: 34px;
  }

  .page-content-desc {
    margin-top: 16px;
    align-items: flex-start;
    justify-content: center;
    height: 58px;
  }

  .page-content-desc-info p {
    line-height: 24px;
  }

  .page-content-desc-icon {
    margin-right: 6px;
  }

  .page-content-btn {
    height: 30px;
    margin-top: 26px;
  }

  .page-content-btn-body {
    height: 30px;
    width: 82px;
  }
</style>
